import { Injectable } from '@angular/core';

import { Mutation, gql } from 'apollo-angular';

import { MutationRemoveCartArgs, RemoveCartPayload } from '@hdms/shared/common-types';

export interface RemoveCartResponse {
  removeCart: RemoveCartPayload;
}

@Injectable({
  providedIn: 'root'
})
export class RemoveCartGqlService extends Mutation<RemoveCartResponse, MutationRemoveCartArgs> {
  override document = gql`
    mutation RemoveCart($input: RemoveCartInput!) {
      removeCart(input: $input) {
        status
      }
    }
  `;
}
